<template>
  <div class="app-content" :class="$router.currentRoute.name">
  </div>
</template>

<script>
export default {
  name: "User",
  mounted() {
    let highlighted = document.querySelector('.region-highlighted');
    let content = document.querySelector('.region-content');
    let message_wrapper = document.querySelector('.messages__wrapper');
    let actions = document.querySelector('#edit-actions');
    this.$el.append(highlighted);
    this.$el.append(content);
    if (message_wrapper) {
      actions.classList.add('error');
      message_wrapper.classList.add('show');
      setTimeout(()=>{
        message_wrapper.classList.add('animate');
      },200);
      let forgotlink = document.querySelector('a[href*="/user/password?name="]');
      if (forgotlink) {
        forgotlink.remove();
      }
      actions.insertBefore(message_wrapper, actions.firstChild);
    }
  },
  data() {
    return {
    };
  },
};
</script>
<style lang="scss">
#edit-actions input {
  margin: 0;
}

.page-user-login, .page-user-password {
  .form-actions {
    margin-bottom: 16px;
    padding-top: 16px;

    &.error {
      padding-top: 0px;
    }
    .messages__wrapper .messages {
      margin-bottom: 16px !important;
    }
  }
  .region-highlighted {
    .messages__wrapper {
      display: none;

    }
  }
  .region-content {
    .messages__wrapper {
      max-height: 0;
      transition: .7s;
      transition-delay: .1s;
      overflow: hidden;
      opacity: 0;
      &.show {
        display: block;
        &.animate {
          max-height: 300px;
          opacity: 1;
        }
      }
    }
  }
}

</style>
